export default __webpack_public_path__ + "static/media/loader.b1062729.gif";